export class Configuration {
  constructor() {
    this.favIcon = '';
    this.title = '';
    this.navLogoUrl = '';
    this.navLogoLink = '';
    this.navTitle = '';
    this.footerText = '';
    this.howCanWeHelpText = '';
    this.paymentFormCompanyName = '';
    this.backgroundColour = '';
    this.buttonPrimaryColour = '';
    this.buttonPrimaryBackgroundColour = '';
    this.buttonPreviousColour = '';
    this.buttonPreviousBackgroundColour = '';
    this.buttonToggleColour = '';
    this.buttonToggleBackgroundColour = '';
    this.buttonPayNowColour = '';
    this.buttonPayNowBackgroundColour = '';
    this.graphValueColour = '';
    this.graphNoValueColour = '';
    this.checkboxColour = '';
    this.wizardStepColour = '';
    this.wizardStepToDoColour = '';
    this.invalidBankAccountNumbers = [];
  }

  favIcon: string;
  title: string;
  navLogoUrl: string;
  navLogoLink: string;
  navTitle: string;
  footerText: string;
  howCanWeHelpText: string;
  paymentFormCompanyName: string;
  invalidBankAccountNumbers: Array<string>;

  // Styling specific (CSS)
  backgroundColour: string;
  buttonPrimaryColour: string;
  buttonPrimaryBackgroundColour: string;
  buttonPreviousColour: string;
  buttonPreviousBackgroundColour: string;
  buttonToggleColour: string;
  buttonToggleBackgroundColour: string;
  buttonPayNowColour: string;
  buttonPayNowBackgroundColour: string;
  graphValueColour: string;
  graphNoValueColour: string;
  checkboxColour: string;
  wizardStepColour: string;
  wizardStepToDoColour: string;
  tcnChatApiKey?: string;
}
